<div class="sidebar-header">
    <div class="listing-identity">
        <div class="listing-logo">
            @if (listingLogo() && !logoErrored()) {
                <img [src]="listingLogo()" alt="Supplier logo" (error)="logoErrored.set(true)" />
            } @else {
                <i class="far fa-building fa-fw"></i>
            }
        </div>
        <div class="listing-meta">
            @if (sidebarType() !== ContextAwareSidebarType.BULK) {
                <span class="listing-code">{{ listingCode() }}</span>
            }
            <span class="editing-indicator">
                <i [class]="editingStatusInfo().icon"></i>
                {{ editingStatusInfo().text }}
            </span>
        </div>
        @if (sidebarType() !== ContextAwareSidebarType.BULK) {
            <app-gauge
                class="header-gauge"
                [percentage]="contentScoringService.scoreResult()?.totalScore || 0"
                [isCircleMode]="true"
                (click)="openContentScoringModal()"
            ></app-gauge>
            <div class="part-statuses">
                @if (contentStatusInfo(); as contentStatus) {
                    <span class="part-status">
                        <span class="part-status__dot part-status__dot--{{ contentStatus.tone }}"></span>
                        {{ 'listing.validationIssues.categoryContent' | translate }} · {{ contentStatus.label | translate }}
                    </span>
                }
                @if (visualsStatusInfo(); as visualsStatus) {
                    <span class="part-status">
                        <span class="part-status__dot part-status__dot--{{ visualsStatus.tone }}"></span>
                        {{ 'listing.validationIssues.categoryVisuals' | translate }} · {{ visualsStatus.label | translate }}
                    </span>
                }
            </div>
        }
    </div>
    @if (showBackToListingButton()) {
        <div class="back-to-listing" [routerLink]="backToListingRouterLink()">
            <div class="back-to-listing-inner">
                <i class="far fa-chevron-left"></i>
                <p>{{ listingName() }}</p>
            </div>
        </div>
    }
    @if (sidebarType() === ContextAwareSidebarType.BULK) {
        <h2 class="listing-name">{{ 'listing.bulk.sidebar.editingMultipleListings' | translate }}</h2>
    } @else {
        <h2 class="listing-name">{{ titleToDisplay() }}</h2>
    }
    <app-context-aware-sidebar-actions
        [listing]="contextAwareSidebarService.listing()"
        [forOutlet]="sidebarType() === ContextAwareSidebarType.OUTLET"
        [forRoom]="sidebarType() === ContextAwareSidebarType.ROOM"
        [bulkMode]="sidebarType() === ContextAwareSidebarType.BULK"
        [bulkListingCount]="contextAwareSidebarService.bulkListingCount()"
    ></app-context-aware-sidebar-actions>
</div>

<div class="sidebar-search">
    <div class="navigationSearchWrapper">
        <label for="contextSidebarSearch">
            <i class="far fa-search"></i>
        </label>
        <input
            type="text"
            [placeholder]="'listing.contextAwareSidebarNavigation.search' | translate"
            id="contextSidebarSearch"
            [value]="searchQuery()"
            (input)="updateSearchQuery($any($event.target).value)"
        />
        @if (searchQuery()) {
            <button class="button small transparent icon" (click)="updateSearchQuery('')">
                <i class="far fa-close"></i>
            </button>
        }
    </div>
</div>

<nav class="sidebar-nav">
    @for (item of viewItems(); track item.id) {
        <div class="nav-section">
            <button
                class="parent-item"
                [class.is-expanded]="item.isExpanded"
                [class.is-active]="item.isActive"
                [class.is-highlighted]="item.isHighlighted"
                (click)="handleParentClick(item)"
            >
                <div class="parent-item__label">
                    <i class="icon far fa-{{ item.icon }} fa-fw"></i>
                    <span>{{ 'listing.featureGroups.' + item.translationKey | translate }}</span>
                </div>
                @if (item.children && item.children.length) {
                    <button class="chevron-button" (click)="handleChevronClick($event, item.id)">
                        <i class="chevron far fa-fw" [class.fa-chevron-down]="!item.isExpanded" [class.fa-chevron-up]="item.isExpanded"></i>
                    </button>
                }
            </button>

            @if (item.isExpanded && item.visibleChildren.length) {
                <div class="children-container">
                    <div class="children-list">
                        @for (child of item.visibleChildren; track child.id) {
                            @if (item.customNavigationTarget) {
                                <button
                                    class="child-item child-item--dynamic"
                                    [class.is-highlighted]="child.isHighlighted"
                                    (click)="handleChildClick(item, child)"
                                >
                                    {{ child.translationKey }}
                                </button>
                            } @else {
                                <a
                                    class="child-item"
                                    [class.is-highlighted]="child.isHighlighted"
                                    [routerLink]="child.routerLinkSegments"
                                    routerLinkActive="is-active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    >{{ 'listing.featureGroups.' + child.translationKey | translate }}</a
                                >
                            }
                        }
                        @if (item.hiddenChildrenCount > 0) {
                            <a class="show-more" [routerLink]="item.showMoreRouterLinkSegments">
                                {{
                                    'listing.contextAwareSidebarNavigation.viewAll' | translate: { numberOfItems: item.totalChildrenCount }
                                }}
                            </a>
                        }
                    </div>
                </div>
            }
        </div>
    }
</nav>
